import React, { useState, useEffect, useRef } from 'react';
import { Text } from '@fluentui/react';
import './TopNews.scss';
import { Trans } from 'react-i18next';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import NewsCard from '../../newsCard/NewsCard';
import { ArticlesHomeDto } from 'generated/article-backend';
interface IProps {
    articles?: ArticlesHomeDto;
}
const TopNews: React.FC<IProps> = (props: IProps) => {
    const { articles } = props;
    const [topStoriesData, setTopStoriesData] = useState([]);
    const [topStoriesRotated] = useState(true);
    const articleCardsRef = useRef<NodeListOf<Element>>(null);

    useEffect(() => {
        setTopStoriesData(articles?.topStories);
    }, [articles]);

    useEffect(() => {
        articleCardsRef.current = document.querySelectorAll("div.slick-slide");
        const hiddenButtons = document.querySelectorAll("div.slick-slide[aria-hidden='true'] button");

        hiddenButtons.forEach(button => {
            button.setAttribute("tabindex", "-1");
        });
    }, [topStoriesData]);

    const toggleFocus = () => {
        articleCardsRef.current?.forEach(card => {
            if(card.hasAttribute("aria-hidden")) {
                let visibility = "-1";
                let isDisabled = true;

                if(card.getAttribute("aria-hidden") === 'false') {
                    visibility = "0";
                    isDisabled = false;
                }

                const buttons = card.querySelectorAll("button");

                buttons.forEach(button => {
                    button.setAttribute("tabindex", visibility);
                    button.toggleAttribute("disabled", isDisabled);
                });
            }
        });
    }

    const departingButtons = useRef<NodeListOf<Element>>(null);

    const disableDepartingButtons = (oldIndex:Number) => {
        departingButtons.current = document.querySelectorAll(`div.slick-slide[data-index='${oldIndex}'] button`);
        departingButtons.current.forEach(btn => {
            btn.toggleAttribute("disabled", true);
        });
    }
    
    const settings = {
        dots: false,
        infinite: topStoriesData.length > 5,
        slidesToShow: topStoriesData.length < 5 ? topStoriesData.length : 5,
        slidesToScroll: 1,
        arrows: false,
        autoplaySpeed: 5000,
        autoplay: true,
        vertical: true,
        pauseOnFocus: true,
        afterChange: toggleFocus,
        beforeChange: disableDepartingButtons
    };

    return (
        <>
            <div className="container news-section">
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl9">
                            <div className="ms-Grid left" dir="ltr">
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                        {articles?.latestFromSurface[0] && (
                                            <NewsCard
                                                size="news-card--wide"
                                                data={articles?.latestFromSurface[0]}
                                                showMoreOptions={false}
                                                showLastEdited={false}
                                                showStatus={false}
                                                showArticleType={false}
                                            />
                                        )}
                                    </div>
                                </div>
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6 p-r-20">
                                        {articles?.latestFromSurface[1] && (
                                            <NewsCard
                                                className="m-b-0 latest--card"
                                                data={articles?.latestFromSurface[1]}
                                                showMoreOptions={false}
                                                showLastEdited={false}
                                                showStatus={false}
                                                showArticleType={false}
                                            />
                                        )}
                                    </div>
                                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl6  p-l-20">
                                        {articles?.latestFromSurface[2] && (
                                            <NewsCard
                                                className="m-b-0 latest--card"
                                                data={articles?.latestFromSurface[2]}
                                                showMoreOptions={false}
                                                showLastEdited={false}
                                                showStatus={false}
                                                showArticleType={false}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl3">
                            {topStoriesData?.length > 0 && (
                                <Text className="article-heading">
                                    <Trans>Top Stories This Week</Trans>
                                </Text>
                            )}
                            <div className="top-stories-container">
                                <Slider {...settings} aria-hidden="true">
                                    {topStoriesRotated &&
                                        topStoriesData?.length > 0 &&
                                        topStoriesData.map((data) => (
                                            <NewsCard
                                                key={data.id}
                                                hideCoverImage={true}
                                                hideDescription={true}
                                                size="news-card--small"
                                                data={data}
                                                showMoreOptions={false}
                                                showLastEdited={false}
                                                showStatus={false}
                                                showArticleType={false}
                                            />
                                        ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TopNews;
